import {
  Box,
  Flex,
  Icon,
  Link,
  Menu,
  MenuButton,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import {
  FaAlignLeft,
  FaAlignRight,
  FaMapMarked,
  FaStore,
  FaUser,
  FaReceipt,
  FaReadme,
} from 'react-icons/fa';
import { connect } from 'react-redux';
import NavItem from '../navitem';

function Sidebar(props) {
  const [navSize, changeNavSize] = useState('large');

  const { accessModules, user } = props;
  const userManagementModule = accessModules?.find(
    (a) => a.module === 'user-management',
  );
  const storeManagementModule = accessModules?.find(
    (a) => a.module === 'store-management',
  );
  const storeLocatorModule = accessModules?.find(
    (a) => a.module === 'store-locator',
  );
  const customerLocatorModule = accessModules?.find(
    (a) => a.module === 'customer-management',
  );
  const reportsModule = accessModules?.find((a) => a.module === 'reports');
  const inventoryModule = accessModules?.find((a) => a.module === 'inventory-manager');

  const hasLoyalCustomers = user?.merchantAccount?.Stores?.items?.some(
    (store) => store.addLoyalCustomers === true
  );

  console.log("userstores", user)
  return (
    <>
      <Flex
        mr="5"
        display={{ base: 'none', md: 'flex' }}
        pos="sticky"
        boxShadow="0 4px 12px 0 rgba(0, 0, 0, 0.05)"
        w={navSize === 'small' ? '45px' : '85px'}
        flexDir="column"
        justifyContent="space-between"
        bg={useColorModeValue('brand.red', '#363636')}
        color="#fff"
      >
        <Flex
          flexDir="column"
          w="100%"
          alignItems={navSize === 'small' ? 'center' : 'flex-start'}
          as="nav"
          fontSize="12"
        >
          <Menu placement="right">
            <Link
              color={useColorModeValue('brand.white', 'brand.black')}
              mt={2}
              p={2}
              href
              onClick={() => {
                if (navSize === 'small') changeNavSize('large');
                else changeNavSize('small');
              }}
              _hover={{
                textDecor: 'none',
                backgroundColor: 'brand.green',
              }}
              w={navSize === 'large' && '100%'}
            >
              <MenuButton w="100%">
                <Icon
                  as={navSize === 'small' ? FaAlignRight : FaAlignLeft}
                  boxSize="8"
                  color={useColorModeValue('brand.white', 'brand.black')}
                />
                <Box display={navSize === 'small' ? 'none' : 'flex'}>
                  Collapse Menu
                </Box>
              </MenuButton>
            </Link>
          </Menu>
          {userManagementModule?.actions.indexOf('full') > -1 && (
            <NavItem
              navSize={navSize}
              icon={FaUser}
              title="User Management"
              link="/users"
            />
          )}
          {storeManagementModule?.actions.indexOf('full') > -1 && (
            <NavItem
              navSize={navSize}
              icon={FaStore}
              title="Store management"
              link="/stores"
            />
          )}
          {storeLocatorModule?.actions.indexOf('full') > -1 && (
            <NavItem
              navSize={navSize}
              icon={FaMapMarked}
              title="Store Locator"
              link="/store-locator"
            />
          )}
          {/* {reportsModule?.actions.indexOf('full') > -1 && (
            <NavItem
              navSize={navSize}
              icon={FaMapMarked}
              title="Reports"
              link="/reports"
            />
          )} */}
          {reportsModule?.actions.indexOf('full') > -1 && (
            <NavItem
              navSize={navSize}
              icon={FaReceipt}
              title="Generate Reports"
              link="/reports"
            />
          )}
           {hasLoyalCustomers && customerLocatorModule?.actions.indexOf('full') > -1 && (
            <NavItem
              navSize={navSize}
              icon={FaMapMarked}
              title="Loyal Customer Phone Orders"
              link="/customers"
            />
          )}
            {/* {inventoryModule?.actions.indexOf('full') > -1 && ( */}
            <NavItem
              navSize={navSize}
              icon={FaReceipt}
              title="Inventroy Manager"
              link="/inventory-manager"
            />
            {/* )} */}
     
        </Flex>
      </Flex>
    </>
  );
}

const stateMapper = (state) => ({
  accessModules: state.auth.accessModules,
  user: state.auth.user,
});
const dispatchMapper = (dispatch) => ({
  setCurrentPath: dispatch.page.setCurrentPath,
});

export default connect(stateMapper, dispatchMapper)(Sidebar);
